/**
 * [SNAKE TIMER REV] Snake pick-timer shape, shared by the wizard control, the
 * Step 8 review, the lobby settings grid and both live clock surfaces.
 *
 * Snake-only. Auction bid / nomination / anti-snipe timing is untouched.
 *
 *   pick_timer_enabled: boolean   ← "Do you want a pick timer?"
 *   pick_timer_seconds: number    ← ignored entirely when disabled
 */
export const PICK_TIMER_PRESETS = [30, 60, 120];
export const PICK_TIMER_MIN_SECONDS = 10;
export const PICK_TIMER_MAX_SECONDS = 600; // 10:00, the clean cap
export const PICK_TIMER_CUSTOM_MINUTES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
export const PICK_TIMER_CUSTOM_SECONDS = [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55];
export const UNTIMED_LABEL = "No time limit";

/** Seconds → "0:45" / "1:30" / "10:00". */
export function formatClock(totalSeconds) {
  const s = Math.max(0, Math.floor(Number(totalSeconds) || 0));
  return `${Math.floor(s / 60)}:${String(s % 60).padStart(2, "0")}`;
}

/** Settings-row copy: "No limit" when the timer is switched off. */
export function pickTimerLabel(enabled, seconds) {
  return enabled === false ? "No limit" : formatClock(seconds);
}

/** True when a league's snake picks are untimed. Absent key = timed (legacy). */
export function isUntimed(settingsOrState) {
  return (settingsOrState || {}).pick_timer_enabled === false;
}
